export default __webpack_public_path__ + "static/media/sponsor.227e142c.jpg";